import { isUserStaff } from "@jasper/shared";
import { useNavigate } from "react-router-dom";
import { IconBell } from "@tabler/icons-react";
import { UseAuth } from "/@/contexts";
import { NavbarHeader } from "./NavbarHeader";
import { NotificationsMenu } from "./NotificationsMenu";
import { OrderStatusMenu } from "./OrderStatusMenu";
import { StaffToolsMenu } from "./StaffToolsMenu";
import { NavLink } from "./NavLink";
import { asUser } from "./helpers/navMenu";
import { useIsPathActive } from "./hooks/useIsPathActive";
import { useNavbarNotifications } from "./hooks/useNavbarNotifications";

export const Navbar = () => {
  const { user } = UseAuth();
  const navigate = useNavigate();
  const isPathActive = useIsPathActive();
  const {
    chatNotification,
    helpNotification,
    orderDesignNotification,
    designReviewNotification,
    newCases,
  } = useNavbarNotifications();

  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      <NavbarHeader />

      <div>
        {isUserStaff(asUser(user)) ? (
          <NotificationsMenu
            chatNotification={chatNotification}
            helpNotification={helpNotification}
            orderDesignNotification={orderDesignNotification}
            designReviewNotification={designReviewNotification}
          />
        ) : (
          <NavLink
            title="NOTIFICATIONS"
            onClick={() => navigate(`/chats?page=0`)}
            active={isPathActive("/chats")}
            notificationNumber={chatNotification}
            icon={<IconBell />}
          />
        )}
      </div>

      <OrderStatusMenu newCases={newCases} />

      <StaffToolsMenu />
    </div>
  );
};
